import { notEmpty } from './array';

export type QueryValueStrict = string | boolean | number | Date;
export type QueryValue = QueryValueStrict | undefined;
export type QueryParamData = { [K in string]: QueryValue | QueryValue[] };

export function toQueryParams(data: QueryParamData | undefined) {
  if (data === undefined) {
    return '';
  }
  const params = new URLSearchParams();
  Object.entries(data).forEach(([key, value]) => {
    const v = serialize(value);
    if (v !== undefined) {
      params.append(key, v);
    }
  });

  return params.toString() ? `?${params.toString()}` : '';
}

function serialize(value: QueryValue | QueryValue[]) {
  if (Array.isArray(value)) {
    const values = value.map(serializeValue).filter(notEmpty);
    return values.length === 0 ? undefined : values.join(',');
  }
  return serializeValue(value);
}

function serializeValue(value: QueryValue) {
  if (value === undefined || value === null) {
    return undefined;
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  return String(value);
}
